import store from '@/store/index'
/**
 *
 * @description 自定义指令： v-has， 判断是否拥有按钮资源权限
 * @description 需要在外层包裹父节点
 * @param {app} app vue实例
 */
function authCheck(app) {
    app.directive('has', {
        updated: function (el, binding) {
            const value = binding.value.toString()
            const auths = app.$_has(value)
            if (value && !auths) {
                if (el.parentNode !== null) {
                    el.parentNode.removeChild(el)
                }
            }
        },
        mounted: function (el, binding) {
            const value = binding.value.toString()
            const auths = app.$_has(value)
            if (value && !auths) {
                if (el.parentNode !== null) {
                    el.parentNode.removeChild(el)
                }
            }
        },
    })
    // 权限检查方法
    app.$_has = function (value) {
        let isExist = false
        const btnPermissionsArr = store.getters.btnPermissions
        if (btnPermissionsArr === undefined || btnPermissionsArr === null) {
            return false
        }
        if (btnPermissionsArr.indexOf(value) > -1) {
            isExist = true
        } else {
            isExist = false
        }
        return isExist
    }
}

/**
 * 判断当前账号是否有“传入的权限key”的权限
 * @param {string} value 权限key
 * @returns {boolean} true-有这个权限
 */
export function hasPermission(value) {
    let isExist = false
    const btnPermissionsArr = store.getters.btnPermissions
    if (btnPermissionsArr === undefined || btnPermissionsArr === null) {
        return false
    }
    if (btnPermissionsArr.indexOf(value) > -1) {
        isExist = true
    } else {
        isExist = false
    }
    return isExist
}

export default {
    install: authCheck,
}
